import { boolean, Decoder, number, object, string } from '@mojotech/json-type-validation'

import { Problem } from '@/domain/entities/problem/problem'

export const problemDecoder: Decoder<Problem> = object({
  id: string(),
  available: number(),
  doctype: number(),
  name: string(),
  problemMemoryLimit: number(),
  problemTimeLimit: number(),
  maxScore: number(),
  solvedUser: number(),
  submissions: number(),
  recommendations: number(),
  isSolved: boolean(),
  bookmark: boolean(),
  recommend: boolean(),
  successRate: number(),
  score: number(),
  userScore: number()
})
